import { useCallback, useContext, useEffect, useState } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { BudgetErrorMessages, RangeType } from '../constants';

export type Errors = {
  [RangeType: string]: BudgetErrorMessages;
};

type ErrorState = {
  errors: Errors;
  updateErrors: (rangeType: RangeType, value?: number) => void;
};

const errorMessageMap = {
  downPayment: BudgetErrorMessages.UnderMinCashDown,
  max: BudgetErrorMessages.UnderMinPrice,
  min: BudgetErrorMessages.OverMaxPrice,
  monthlyPayment: BudgetErrorMessages.OverMaxMonthly
};

export default function useBudgetPanelErrors(): ErrorState {
  const [errors, setErrors] = useState<Errors>({});
  const { appliedFilters } = useContext(AppliedFiltersContext);

  // reset errors if clear all is clicked
  useEffect(() => {
    if (!appliedFilters.price) {
      setErrors({});
    }
  }, [appliedFilters]);

  const updateErrors = useCallback((rangeType: RangeType, value?: number) => {
    if (rangeType && value !== undefined) {
      setErrors(currentErrors => ({
        ...currentErrors,
        [rangeType]: errorMessageMap[rangeType]
      }));
    } else {
      setErrors({});
    }
  }, []);

  return { errors, updateErrors };
}
